// The banner palette mirrors the six action-type categories of the new app
// (gnowbe-frontend-2: packages/ui/src/utils/actionColors.ts) and uses those
// exact hexes. Only the light-mode values, since banners are not themed.

export type BannerColor = {
  label: string,
  value: string,
}

export const bannerColors: BannerColor[] = [
  { label: 'White', value: '#FFFFFF' },
  { label: 'Learn', value: '#1C4E53' },
  { label: 'Inspire', value: '#117BB4' },
  { label: 'Explore', value: '#F46937' },
  { label: 'Think', value: '#0B7346' },
  { label: 'Apply', value: '#DD3D55' },
  { label: 'Share', value: '#7F36C1' },
]

// The six category colors always carry white text, as the action-type tags in
// the new app do. EXPLORE orange needs to be named explicitly: its luminance
// lands just on the light side of the threshold below, so it would otherwise
// come out with dark text.
const darkBannerColors = new Set(bannerColors.slice(1).map(c => c.value))

/** Whether a banner background needs light text on top of it. */
export const isDarkBannerColor = (color?: string | null): boolean => {
  const hex = (color || '').trim().replace('#', '')
  if (!/^[0-9a-fA-F]{6}$/.test(hex)) return false

  if (darkBannerColors.has(`#${hex.toUpperCase()}`)) return true

  // Banners created before this palette use pastel colors, so fall back to
  // luminance instead of assuming anything unknown is light.
  const rgb = parseInt(hex, 16)
  const luma = 0.2126 * ((rgb >> 16) & 0xff) + 0.7152 * ((rgb >> 8) & 0xff) + 0.0722 * (rgb & 0xff)

  return luma < 128
}

/** Text color class for content sitting on a banner background. */
export const bannerTextCn = (color?: string | null) => isDarkBannerColor(color) ? 'text-white' : 'text-deepgray'

/** Border color class for controls sitting on a banner background. */
export const bannerBorderCn = (color?: string | null) => isDarkBannerColor(color) ? 'border-white' : 'border-deepgray'
